import { Box, Flex, Heading, Image, Link, Text } from '@chakra-ui/react';
import React from 'react';

type Props = {
  item: any
};

function WorkItem({ item }: Props) {

  return (
    <div>
      <Heading size="2xl" color="b.wh" pb="6" marginLeft="3">
        {item.title}
      </Heading>
      <Box w={{base: '138px', lg: '288px'}} h={{base: '138px', lg: '288px'}}  borderRadius="24" marginRight="3" marginLeft="3" bgColor={`b.${item.meta.mainbanner_background}`} className="item">
        <Link href={item.meta.mainbanner_url} target={item.meta.mainbanner_target}>
        <Image src={item.featured_full} objectFit="cover" borderRadius="24" w={{base: '138px', lg: '288px'}} h={{base: '138px', lg: '288px'}} className="item-image" />
        <Box padding="8" className="item-text">
          <Flex h={{base: '100px', lg: '320px'}} justify="space-between" direction="column">
            <Text fontSize={{base: 'sm', lg: 'xl'}} color="b.wh" lineHeight="1.4" fontWeight="bold" noOfLines={{base: 4, lg: 7}}>
              {item.content}
            </Text>
            <Link fontSize={{base: 'md', lg: 'xl'}} color="b.wh" fontWeight="bold">
              <Flex align="center">
                바로가기
                <Image src="/images/icons/link_w.svg" w={{base: '16px', lg: '32px'}} objectFit="cover" />
              </Flex>
            </Link>
          </Flex>
        </Box>
        </Link>
      </Box>
    </div>
  );
}

WorkItem.defaultProps = {
};

export default WorkItem;